import { useQuery } from '@tanstack/react-query';
import { fetchShipmentRoutingTypes } from '../../data-provider/select-options';

export const useGetShipmentRoutingTypes = () => {
  return useQuery({
    queryKey: ['shipment-routing-types'],
    queryFn: () => fetchShipmentRoutingTypes(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
